import { render, staticRenderFns } from "./AttemptSoal.vue?vue&type=template&id=b797c5fa"
import script from "./AttemptSoal.vue?vue&type=script&lang=js"
export * from "./AttemptSoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports